import { render, staticRenderFns } from "./commercialCompanyinquiry.vue?vue&type=template&id=ca3318d0&scoped=true"
import script from "./commercialCompanyinquiry.vue?vue&type=script&lang=js"
export * from "./commercialCompanyinquiry.vue?vue&type=script&lang=js"
import style0 from "./commercialCompanyinquiry.vue?vue&type=style&index=0&id=ca3318d0&prod&scoped=true&lang=css"
import style1 from "./commercialCompanyinquiry.vue?vue&type=style&index=1&id=ca3318d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3318d0",
  null
  
)

export default component.exports